"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollShiftListItemDtoShiftTypeEnum = void 0;
exports.instanceOfPayrollShiftListItemDto = instanceOfPayrollShiftListItemDto;
exports.PayrollShiftListItemDtoFromJSON = PayrollShiftListItemDtoFromJSON;
exports.PayrollShiftListItemDtoFromJSONTyped = PayrollShiftListItemDtoFromJSONTyped;
exports.PayrollShiftListItemDtoToJSON = PayrollShiftListItemDtoToJSON;
exports.PayrollShiftListItemDtoToJSONTyped = PayrollShiftListItemDtoToJSONTyped;
const PayrollShiftFacilityDto_1 = require("./PayrollShiftFacilityDto");
const PayrollShiftNurseProfileDto_1 = require("./PayrollShiftNurseProfileDto");
const PayrollShiftOnCallDto_1 = require("./PayrollShiftOnCallDto");
const PayPeriodDto_1 = require("./PayPeriodDto");
/**
 * @export
 */
exports.PayrollShiftListItemDtoShiftTypeEnum = {
    Clinical: 'CLINICAL',
    Orientation: 'ORIENTATION',
    OnCall: 'ON_CALL'
};
/**
 * Check if a given object implements the PayrollShiftListItemDto interface.
 */
function instanceOfPayrollShiftListItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('shiftType' in value) || value['shiftType'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('didNotWork' in value) || value['didNotWork'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    if (!('onCallShift' in value) || value['onCallShift'] === undefined)
        return false;
    if (!('payPeriods' in value) || value['payPeriods'] === undefined)
        return false;
    return true;
}
function PayrollShiftListItemDtoFromJSON(json) {
    return PayrollShiftListItemDtoFromJSONTyped(json, false);
}
function PayrollShiftListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'shiftType': json['shiftType'],
        'specialtyCode': json['specialtyCode'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'minutesWorked': json['minutesWorked'],
        'didNotWork': json['didNotWork'],
        'facility': (0, PayrollShiftFacilityDto_1.PayrollShiftFacilityDtoFromJSON)(json['facility']),
        'nurseProfile': (0, PayrollShiftNurseProfileDto_1.PayrollShiftNurseProfileDtoFromJSON)(json['nurseProfile']),
        'onCallShift': (0, PayrollShiftOnCallDto_1.PayrollShiftOnCallDtoFromJSON)(json['onCallShift']),
        'payPeriods': (json['payPeriods'].map(PayPeriodDto_1.PayPeriodDtoFromJSON)),
    };
}
function PayrollShiftListItemDtoToJSON(json) {
    return PayrollShiftListItemDtoToJSONTyped(json, false);
}
function PayrollShiftListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'shiftType': value['shiftType'],
        'specialtyCode': value['specialtyCode'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'minutesWorked': value['minutesWorked'],
        'didNotWork': value['didNotWork'],
        'facility': (0, PayrollShiftFacilityDto_1.PayrollShiftFacilityDtoToJSON)(value['facility']),
        'nurseProfile': (0, PayrollShiftNurseProfileDto_1.PayrollShiftNurseProfileDtoToJSON)(value['nurseProfile']),
        'onCallShift': (0, PayrollShiftOnCallDto_1.PayrollShiftOnCallDtoToJSON)(value['onCallShift']),
        'payPeriods': (value['payPeriods'].map(PayPeriodDto_1.PayPeriodDtoToJSON)),
    };
}
//# sourceMappingURL=PayrollShiftListItemDto.js.map